import { Skeleton } from "skullet/react";
import { Header } from "@/components/Header";

export function ListingPageSkeleton() {
    return (
        <div className="min-h-dvh w-full flex flex-col bg-true-white">
            <Header className="hidden md:block bg-true-white" />
            <div className="pt-23.25 hidden md:block" />
            <Skeleton loading label="Loading dog">
                <div className="mx-auto flex w-full max-w-7xl flex-col px-6 pt-8">
                    <div className="flex flex-col items-center gap-3 md:items-start">
                        <div skullet-block="" className="h-5 w-48 rounded" />
                        <div skullet-block="" className="h-9 w-72 rounded" />
                        <div className="mt-2 flex gap-1.5">
                            <div
                                skullet-block=""
                                className="h-7 w-20 rounded-full"
                            />
                            <div
                                skullet-block=""
                                className="h-7 w-20 rounded-full"
                            />
                            <div
                                skullet-block=""
                                className="h-7 w-20 rounded-full"
                            />
                        </div>
                    </div>
                    <div
                        skullet-block=""
                        className="mt-6 h-64 w-full rounded-card md:rounded-card-lg"
                    />
                    <div className="mt-8 flex flex-col gap-8 lg:grid lg:grid-cols-[minmax(0,1fr)_390px] lg:gap-10">
                        <div className="flex flex-col gap-4">
                            <div
                                skullet-block=""
                                className="h-7 w-40 rounded"
                            />
                            <div
                                skullet-block=""
                                className="h-4 w-full rounded"
                            />
                            <div
                                skullet-block=""
                                className="h-4 w-3/4 rounded"
                            />
                        </div>
                        <div skullet-block="" className="h-72 rounded-card" />
                    </div>
                </div>
            </Skeleton>
        </div>
    );
}
